import { combineReducers } from 'redux';
import directMerchants from './directMerchants';
import filters from './filters';
import views from './views';

const reducer = combineReducers({
  filters,
  directMerchants,
  views
});

export default reducer;
